import { FC } from "react";

export const Stock: FC = () => {
  return <>Stock</>;
};
